import ControllerBase from './../../../../global/js/ControllerBase';


interface ComponentRefs {
	select: 'select',
}
export default class ControllerIndexNav extends ControllerBase<ComponentRefs> {

	/** The HTML select box */
	private readonly selectControl: HTMLSelectElement;

	constructor(element: HTMLElement) {
		super(element);

		this.selectControl = this.$references.select as HTMLSelectElement;
		this.init();
	}

	private init(): void {
		this.observeSelectMenu();
	}

	private observeSelectMenu(): void {
		if (!this.selectControl) return;
		this.selectControl.addEventListener('change', e => this.scrollToPosition(e));
	}

	private scrollToPosition(e: Event): void {

		const bookmark = '#' + this.selectControl.value
		.replace(' ', '-').replace('^A-Za-z0-9', ''); // make this better in related component

		const scrollToElement = document.querySelector<HTMLAnchorElement>(bookmark);
		if (!scrollToElement) return;

		const topPos = scrollToElement.getBoundingClientRect().top + 75; // 75 is to give some extra space

		window.scrollTo({
			top: topPos, // scroll so that the element is at the top of the view
			behavior: 'smooth', // smooth scroll
		});
	}
}
